function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#9B9EA9"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 23.654L5.095 23.654 5.095 0 0 0zM9.979 23.654L15.074 23.654 15.074 0 9.979 0zM19.985 23.654L25.08 23.654 25.08 0 19.985 0z",
  transform: "translate(-345.000000, -136.000000) translate(345.000000, 136.000000)"
}))));

function SvgHamburgerMenuGrey({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenuGrey);
export default __webpack_public_path__ + "static/media/hamburger-menu-grey.2c96d5aa.svg";
export { ForwardRef as ReactComponent };